import { type DropdownItem } from '@/forms-legacy'
import { dateUtils } from '@/utils'
import { getDay, getMonth } from 'date-fns'
import { type RecurrenceWhen } from '../../../../types'
import { createRecurrenceWhenId } from './createRecurrenceWhenId'

export function createAnnuallyOptions(
  selectedDateYYYYMMDD: uui.domain.YYYYMMDD,
  formatRecurrenceWhenLabel: (recurrenceWhen: RecurrenceWhen) => string,
): DropdownItem[] {
  const selectedDate = dateUtils.parseDate(selectedDateYYYYMMDD)
  const cardinal = dateUtils.getWeekdayCardinality(selectedDate)

  const whenRecurrences: RecurrenceWhen[] = [
    {
      type: 'ANNUALLY',
      date: selectedDateYYYYMMDD,
    },
    {
      type: 'ANNUALLY',
      date: selectedDateYYYYMMDD,
      cardinal,
      month: getMonth(selectedDate) + 1, // getMonth returns 0-indexed month
      weekday: getDay(selectedDate),
    },
  ]

  // Create array of objects with day index as key and day name as value
  return whenRecurrences.map<DropdownItem>(recurrenceWhen => {
    return {
      id: createRecurrenceWhenId(recurrenceWhen),
      label: formatRecurrenceWhenLabel(recurrenceWhen),
    }
  })
}
